import { Playground } from 'docz';
import { useLocalStorage } from "../../../../../src/index";
import * as React from 'react';
export default {
  Playground,
  useLocalStorage,
  React
};